export const EVENT_ACTION = {
  SLIDER_PLAY: 'instant_games_play_slider_game',
  SLIDER_REDIRECT: 'instant_games_more_slider_banner',
  MOBILE_NAV_SEARCH: 'instant_games_search_mobile',
  MOBILE_NAV_FAVORITES: 'instant_games_favorites_mobile',
  MOBILE_NAV_SHOW_SIDEBAR: 'instant_games_show_sidebar_mobile',
  LAST_GAME_PLAY: 'instant_games_last_game_play',
  LAST_GAME_DEMO: 'instant_games_last_game_demo',
  CONTINUE_FAVOURITE: 'instant_games_main_last_game_favourite',
  OTHER_GAMES: 'instant_games_other_games_all',
  OTHER_GAMES_PLAY: 'instant_games_other_games_play',
  OTHER_GAMES_DEMO: 'instant_games_other_games_demo',
  OTHER_GAMES_FAVORITE: 'instant_games_main_other_games_favourite',
  ALL_GAMES_FAVOURITE: 'instant_games_main_all_games_favourite',
  PROVIDER: 'instant_games_provider_games_all',
  PROVIDER_PLAY: 'instant_games_provider_games_play',
  PROVIDER_DEMO: 'instant_games_provider_games_demo',
  ALL_PROVIDERS_REDIRECT: 'instant_games_main_widget_providers',
  PROVIDER_REDIRECT: 'instant_games_main_widget_provider',
  ALL_PROVIDERS_CARD_REDIRECT: 'instant_games_main_widget_card_providers',
  PROVIDER_CARD_REDIRECT: 'instant_games_main_widget_card_provider',
  CATEGORY: 'instant_games_category',
  CATEGORY_GAMES: 'instant_games_category_games_all',
  CATEGORY_GAMES_PLAY: 'instant_games_category_games_play',
  CATEGORY_GAMES_DEMO: 'instant_games_category_games_demo',
  CATEGORY_GAMES_FAVORITE: 'instant_games_main_category_games_favourite',
  CASINO_NAVIGATION_CLICK: 'casino_navigation_click',
  ALL_CATEGORIES_REDIRECT: 'instant_games_main_widget_categories',
  CATEGORY_REDIRECT: 'instant_games_main_widget_category',
  NAV_MAIN: 'instant_games_lobby',
  NAV_FAVORITES: 'instant_games_favorites',
  NAV_CATEGORY_ITEM: 'instant_games_category',
  NAV_PROVIDERS: 'instant_games_nav_providers',
  NAV_CATEGORIES: 'instant_games_nav_categories',
  NAV_PROVIDER_ITEM: 'instant_games_nav_provider',
  QUICK_SEARCH_TOP_GAME: 'instant_games_quick_search_top_games_play',
  QUICK_SEARCH_FOUND_GAME: 'instant_games_quick_search_game_play',
  QUICK_SEARCH_ALL_GAMES: 'instant_games_quick_search_all_games',
  QUICK_SEARCH_PREV_GAME: 'instant_games_quich_search_previos_game',
  SEARCH_GAME_PLAY: 'instant_games_search_game_play',
  SEARCH_GAME_DEMO: 'instant_games_search_game_demo',
  SEARCH_GAME_FAVORITE: 'instant_games_search_game_favorite',
  SEARCH_PREVIOUS_GAMES_PLAY: 'instant_games_previous_games_play',
  SEARCH_PREVIOUS_GAMES_DEMO: 'instant_games_previous_games_demo',
  SEARCH_PREVIOUS_GAMES_FAVOURITE: 'instant_games_previous_games_favourite',
  SEARCH_CATEGORY_GAMES: 'instant_games_search_top_games_all',
  SEARCH_CATEGORY_GAMES_PLAY: 'instant_games_search_top_games_play',
  SEARCH_CATEGORY_GAMES_DEMO: 'instant_games_search_top_games_demo',
  SEARCH_CATEGORY_GAMES_FAVOURITE: 'instant_games_search_top_games_favourite',
  GAME_PAGE_DEMO: 'instant_games_play_demo_game',
  GAME_PAGE_REAL: 'instant_games_play_real_game',
  GAME_PAGE_FAVORITE: 'instant_games_add_favourite',
  GAME_PAGE_FULLSCREEN: 'instant_games_fullscreen',
  GAME_PREVIEW_PAGE_DEMO: 'instant_games_preview_play_demo_game',
  GAME_PREVIEW_PAGE_REAL: 'instant_games_preview_play_real_game',
  GAME_PREVIEW_PAGE_CLOSE: 'instant_games_preview_game_close',
  GAME_PAGE_CLOSE: 'instant_games_game_close',
  WAGERING_BONUS_PAGE_SELECT_WAGERING: 'instant_games_casino_wagering',
  WAGERING_BONUS_PAGE_PLAY: 'instant_games_casino_wagering_game_play',
  WAGERING_BONUS_PAGE_FAVOURITE: 'instant_games_casino_wagering_game_favourite',
  FAVORITE_PAGE_PLAY: 'instant_games_favourite_game_play',
  FAVORITE_PAGE_FAVORITE: 'instant_games_favorite_games_favourite',
  GAME_PAGE_SIMILAR_GAMES: 'instant_games_similar',
  GAME_PAGE_SIMILAR_GAMES_PLAY: 'instant_games_similar_play',
  GAME_PAGE_SIMILAR_GAMES_DEMO: 'instant_games_similar_demo',
  GAME_PAGE_OTHER_GAMES: 'instant_games_launch_other_games',
  GAME_PAGE_OTHER_GAMES_PLAY: 'instant_games_launch_other_games_play',
  GAME_PAGE_OTHER_GAMES_DEMO: 'instant_games_launch_other_games_demo',
  GAME_PAGE_PREVIOUS_PLAY: 'instant_games_previous_games_play',
  GAME_PAGE_PREVIOUS_DEMO: 'instant_games_previuos_games_demo',
  PROVIDER_SORT: 'instant_games_provider_sort',
  PROVIDER_SORT_APPLY: 'instant_games_provider_sort_apply',
  CATEGORY_DETAIL_PLAY: 'instant_games_category_details_games_play',
  CATEGORY_DETAIL_DEMO: 'instant_games_category_details_games_demo',
  CATEGORY_DETAIL_FAVORITE: 'instant_games_category_details_games_favourite',
  PROVIDER_DETAIL_GAMES_PLAY: 'instant_games_provider_details_games_play',
  PROVIDER_DETAIL_GAMES_DEMO: 'instant_games_provider_details_games_demo',
  PROVIDER_DETAIL_GAMES_FAVORITE:
    'instant_games_provider_details_games_favourite',
  RANDOM_GAME: 'instant_games_random_game',
  RANDOM_GAME_ERROR: 'instant_games_random_game_error',
  RANDOM_GAME_SUCCESS: 'instant_games_random_game_success',
  MAIN_BALANCE: 'instant_games_main_balance',
  BONUS_TO_GAMES_WAGERING: 'instant_games_bonus_to_games_wagering',

  CROSS_SALE_WIDGET_ALL_GAMES: 'slots_cross_sale_widget_all_games',
  CROSS_SALE_WIDGET_PLAY: 'slots_cross_sale_widget_play_game',
};

export const DATA_LAYER_EVENT = 'instant_games';
export const DATA_LAYER_EVENT_CATEGORY = 'instant_games';
